import { AuthContextType } from '@auth/AuthProvider';
import NetworkController, { HTTPMethod, HTTPRequest, HTTPResponse } from '@data/controller/NetworkController';

export type ConnectionStatusResponse = {
  statuses: Record<ExternalVendor, boolean>
};

export enum ExternalVendor {
  PLANNING_CENTER = 'PLANNING_CENTER',
  SMART_WAIVER = 'SMART_WAIVER'
}

export type ConnectionProviderSetupResponse =
  | {
      authMethod: 'oauth'
      authDetails: ConnectionProviderSetupResponseOAuthDetails
    }
  | {
      authMethod: 'apiKey'
      authDetails: ConnectionProviderSetupResponseAPIKeyDetails
    }

export type ConnectionProviderSetupResponseOAuthDetails = {
  url: string;
}

export type ConnectionProviderSetupResponseAPIKeyDetails = {
  instructions: string;
}

export default class ConnectionsController {
  private static baseURL: string = process.env.REACT_APP_EVENTS_BACKEND_URL || "";

  static async fetchConnectionStatus(churchID: string, auth: AuthContextType): Promise<HTTPResponse<ConnectionStatusResponse>> {
    return await NetworkController.performRequestAt<ConnectionStatusResponse>(
      this.baseURL,
      new HTTPRequest(HTTPMethod.GET, `/connections/${churchID}`),
      auth.consumeRefreshToken
    );
  }

  static async fetchConfigureConnectionURLForProvider(churchID: string, provider: ExternalVendor, auth: AuthContextType): Promise<HTTPResponse<ConnectionProviderSetupResponse>> {
    return await NetworkController.performRequestAt<ConnectionProviderSetupResponse>(
      this.baseURL,
      new HTTPRequest(HTTPMethod.GET, `/connections/${churchID}/${provider}/setup`),
      auth.consumeRefreshToken
    );
  }

  static async saveAPIKeyForProvider(churchID: string, provider: ExternalVendor, apiKey: string, auth: AuthContextType): Promise<HTTPResponse<void>> {
    return await NetworkController.performRequestAt<void>(
      this.baseURL,
      new HTTPRequest(HTTPMethod.POST, `/connections/${churchID}/${provider}/save/api-key`, {
        apiKey
      }),
      auth.consumeRefreshToken
    );
  }
}